import React from 'react';
import {DesktopApp} from "../../../../../../core/gd/desktop-app";
import Button, {ButtonType} from "../../../../../../core/gd-components/buttons/gd-button/gd-button-ui5-new";
import {AppPlatform} from "../../../../../../core/gd/types/types";

type Props = {
    fadeTime:  number
    data    :  any
    close   :  callback
}

export default function GrowlOpenLinksInDesktopApp(props: Props) {

    const onAccept = ()=> {


        switch (gd.appPlatform) {
            case AppPlatform.BROWSER:
                DesktopApp.openLinksInDesktopAppCookie = true
                break

            case AppPlatform.ELECTRON:
                DesktopApp.setSuggestOpenLinksInDesktop(true)
                break

            case AppPlatform.MOBILE:
            default:
                break
        }


        props.close()
    }

    const onCancel = ()=> {

        switch (gd.appPlatform) {
            case AppPlatform.BROWSER:
                DesktopApp.openLinksInDesktopAppCookie = false
                break

            case AppPlatform.ELECTRON:
                DesktopApp.setSuggestOpenLinksInDesktop(false)
                break

            case AppPlatform.MOBILE:
            default:
                break
        }

        props.close()
    }

    const openDesktopAppSettings = ()=> {
        gd.goTo("my-account/desktop-app")
    }

    return (
        <div className="notification min-w-600 p-0 border-all"
             style={{transition: "opacity " + props.fadeTime + "s"}}>

            <div className="flex-row-left-top p-25 ui5-border-bottom">
                <div className="ui5-button selected flex-row-center-center w-45 h-45">
                    <div className="isvg-app-click w-25 h-25"></div>
                </div>

                <div className="m-l-15">
                    <div className="ui5-title-app-name">Open links in the Desktop App?</div>
                    <div className="ui5-txt-less-important m-t-10">Always use the GoodDay Desktop App to open goodday.work links.</div>
                    <div className="ui5-txt-less-important m-t-10">

                        You can change these settings in <span className="ui5-txt-link m-l-5" onClick={openDesktopAppSettings}>Account Settings → Desktop App</span>.

                    </div>
                </div>
            </div>


            <div className="flex-row-left-center p-l-25 p-r-25 p-t-15 p-b-15">

                <div style={{marginLeft: '60px'}} />

                <Button className="m-r-15" label="Yes, open in App" onClick={onAccept}/>
                <Button type={ButtonType.SECONDARY} label="No, thanks" onClick={onCancel}/>


            </div>
        </div>
    )
}

